import React, { useEffect, useState } from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import CurrentRunScreen from './CurrentRunScreen';
import ScheduleScreen from './ScheduleScreen';
import KioskScreen from './KioskScreen';
import ResultsScreen from './ResultsScreen';
import DealsScreen from './DealsScreen';
import { Text, StyleSheet, TouchableOpacity } from 'react-native';
import { RouteProp, useNavigation } from '@react-navigation/native';
import { BLUE, DIVIDER, CARD } from '../../theme/colors';
import { get } from '../../api/client';

const Tab = createBottomTabNavigator();

export default function CompetitionTabs({ route }: { route: RouteProp<any, any> }) {
  const competitionId: number = route?.params?.competitionId;
  const competitionName: string | undefined = route?.params?.competitionName;
  const competitionDate: string | undefined = route?.params?.competitionDate;
  const competitionStatus: string | undefined = route?.params?.competitionStatus;
  const params = { competitionId, competitionName, competitionDate, competitionStatus };
  const navigation = useNavigation();
  // null = still loading, true = open, false = closed / unavailable
  const [kioskOpen, setKioskOpen] = useState<boolean | null>(null);
  const [dealsAvailable, setDealsAvailable] = useState<boolean | null>(null);

  useEffect(() => {
    get<any>(`/competitions/${competitionId}/kiosk`)
      .then(res => setKioskOpen(!!(res?.is_open && res?.kiosks?.length > 0)))
      .catch(() => setKioskOpen(false));
    get<any[]>(`/competitions/${competitionId}/deals`)
      .then(res => setDealsAvailable(Array.isArray(res) && res.length > 0))
      .catch(() => setDealsAvailable(false));
  }, [competitionId]);

  const backButton = () => (
    <TouchableOpacity onPress={() => navigation.goBack()} style={{ paddingHorizontal: 12 }}>
      <Text style={{ color: CARD, fontSize: 16 }}>‹ Tilbake</Text>
    </TouchableOpacity>
  );

  const sharedScreenOpts = {
    tabBarActiveTintColor: BLUE,
    tabBarInactiveTintColor: '#999',
    tabBarStyle: { backgroundColor: CARD, borderTopColor: DIVIDER },
    tabBarLabelStyle: { fontSize: 11, fontWeight: '600' as const },
    headerStyle: { backgroundColor: BLUE },
    headerTintColor: CARD,
    headerTitleStyle: { fontWeight: '700' as const, fontSize: 16, color: CARD },
    headerShadowVisible: false,
    headerLeft: backButton,
  };

  const ICONS: Record<string, string> = { Current: '🏅', Schedule: '🗓️', Kiosk: '☕', Results: '🏆', Deals: '🎁' };

  return (
    <Tab.Navigator
      screenOptions={({ route: r }) => ({
        ...sharedScreenOpts,
        tabBarIcon: ({ focused }) => (
          <Text style={[s.icon, focused && s.iconActive]}>{ICONS[r.name] ?? '•'}</Text>
        ),
      })}
    >
      <Tab.Screen
        name="Current"
        component={CurrentRunScreen}
        initialParams={params}
        options={{ title: competitionName ?? 'På trampetten nå', tabBarLabel: 'Trampetten' }}
      />
      <Tab.Screen
        name="Schedule"
        component={ScheduleScreen}
        initialParams={params}
        options={{ title: 'Tidsplan', tabBarLabel: 'Tidsplan' }}
      />
      <Tab.Screen
        name="Results"
        component={ResultsScreen}
        initialParams={params}
        options={{ title: 'Resultater', tabBarLabel: 'Resultater' }}
      />
      {dealsAvailable === true ? (
        <Tab.Screen
          name="Deals"
          component={DealsScreen}
          initialParams={params}
          options={{ title: 'Tilbud', tabBarLabel: 'Tilbud' }}
        />
      ) : null}
      {kioskOpen === true ? (
        <Tab.Screen
          name="Kiosk"
          component={KioskScreen}
          initialParams={params}
          options={{ title: 'Kiosk', tabBarLabel: 'Kiosk' }}
        />
      ) : null}
    </Tab.Navigator>
  );
}

const s = StyleSheet.create({
  icon:       { fontSize: 18 },
  iconActive: { transform: [{ scale: 1.12 }] },
});
